"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const BlockPlaceholder_1 = require("./BlockPlaceholder");
const indentation_1 = require("../../behavior/indentation");
const font_1 = require("../../behavior/font");
const css_1 = require("../../custom-style/css");
const util_1 = require("../../util");
const headingClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    ls: '-0.03em',
});
const HeadingElement = ({ attributes, children, element }) => {
    const styles = (0, context_1.useStyles)();
    const shared = {
        textAlign: element.align,
        paddingInlineStart: (0, indentation_1.indentPadding)(element.indent),
        fontFamily: (0, font_1.fontFamilyOf)(element.font),
        color: (0, css_1.fgVar)(8, styles.g(0.08)),
    };
    switch (element.type) {
        case 'title':
            return (React.createElement("h1", { ...attributes, className: headingClass, style: {
                    ...shared,
                    fontSize: '3.8rem',
                    fontWeight: 800,
                    letterSpacing: '-0.04em',
                    margin: '48px 0 8px',
                    lineHeight: 1.05,
                } },
                children,
                (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
        case 'subtitle':
            return (React.createElement("p", { ...attributes, className: headingClass, style: {
                    ...shared,
                    fontSize: '1.55rem',
                    fontWeight: 300,
                    margin: '0 0 28px',
                    lineHeight: 1.55,
                    color: (0, css_1.fgVar)(40, styles.g(0.4)),
                } },
                children,
                (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
        case 'h1':
            return (React.createElement("h1", { ...attributes, className: headingClass, style: {
                    ...shared,
                    fontSize: '2.1rem',
                    fontWeight: 800,
                    margin: '40px 0 18px',
                    lineHeight: 1.1,
                } },
                children,
                (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
        case 'h2':
            return (React.createElement("h2", { ...attributes, className: headingClass, style: {
                    ...shared,
                    fontSize: '1.55rem',
                    fontWeight: 700,
                    margin: '34px 0 14px',
                    lineHeight: 1.2,
                } },
                children,
                (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
        case 'h3':
            return (React.createElement("h3", { ...attributes, className: headingClass, style: {
                    ...shared,
                    fontSize: '1.22rem',
                    fontWeight: 700,
                    margin: '26px 0 12px',
                    lineHeight: 1.3,
                    color: (0, css_1.fgVar)(16, styles.g(0.16)),
                } },
                children,
                (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
        case 'h4':
            return (React.createElement("h4", { ...attributes, className: headingClass, style: {
                    ...shared,
                    fontSize: '1.15rem',
                    fontWeight: 700,
                    margin: '22px 0 10px',
                    lineHeight: 1.4,
                    color: (0, css_1.fgVar)(24, styles.g(0.24)),
                } },
                children,
                (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
        case 'h5':
            return (React.createElement("h5", { ...attributes, className: headingClass, style: {
                    ...shared,
                    fontSize: '1.1rem',
                    fontWeight: 700,
                    margin: '18px 0 8px',
                    lineHeight: 1.5,
                    color: (0, css_1.fgVar)(32, styles.g(0.32)),
                } },
                children,
                (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
        case 'h6':
            return (React.createElement("h6", { ...attributes, className: headingClass, style: {
                    ...shared,
                    fontSize: '1rem',
                    fontWeight: 700,
                    margin: '14px 0 6px',
                    lineHeight: 1.6,
                    color: (0, css_1.fgVar)(40, styles.g(0.4)),
                } },
                children,
                (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
        default:
            return React.createElement("div", { ...attributes }, children);
    }
};
exports.HeadingElement = HeadingElement;
